import { useEffect, useState } from "react";
import Api from "../openapi";
import { AreaBriefResponse } from "../openapi/client";

export default function useAreasBrief() {
  const [areaList, setAreaList] = useState<AreaBriefResponse[]>([]);
  useEffect(() => {
    const getAreas = async () => {
      try {
        const res = await Api.Area.listBriefAreas();
        setAreaList(res.data);
      } catch (error) {}
    };
    getAreas();
  }, []);
  return areaList;
}
